module.exports = __webpack_public_path__ + "beaf6bb2d557ca292b34f33554bf188d.jpg";